const Lidar = ({ url }) => (
  <>
    <div className="relative mt-16 overflow-hidden rounded-lg">
      <iframe src={url} allowFullScreen className="w-full aspect-video" />
    </div>
  </>
);

export default Lidar;
